/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const IdeaIcon = ({
  className,
  style,
  color = '#FFC14E',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="35"
      height="28"
      viewBox="0 0 20 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.875 13.5625C9.1504 13.5625 8.5625 14.1498 8.5625 14.875C8.5625 15.5996 9.1504 16.1875 9.875 16.1875C10.5996 16.1875 11.1875 15.5996 11.1875 14.875C11.1875 14.1498 10.5996 13.5625 9.875 13.5625ZM8.9743 11.8398C8.98852 12.0706 9.17993 12.25 9.41071 12.25H10.3388C10.45 12.2499 10.5571 12.2075 10.6381 12.1313C10.7192 12.0551 10.7682 11.9509 10.7752 11.8398L11.158 5.71484C11.1738 5.46273 10.9737 5.25 10.7216 5.25H9.02789C8.77579 5.25 8.57563 5.46273 8.59149 5.71484L8.9743 11.8398ZM9.875 0C4.24493 0 0.243446 4.56859 0.250008 9.63813C0.253289 12.0597 1.15235 14.2685 2.63219 15.9567C4.03493 17.5563 5.38243 20.1622 5.50001 21L5.50329 25.1114C5.50329 25.2837 5.55469 25.4516 5.64985 25.5948L6.99024 27.6095C7.15266 27.8534 7.4261 28 7.71868 28H12.0308C12.3239 28 12.5973 27.8534 12.7592 27.6095L14.0996 25.5948C14.1948 25.4516 14.2456 25.2831 14.2462 25.1114L14.25 21C14.3736 20.1403 15.726 17.5443 17.1178 15.9567C18.6004 14.2652 19.5 12.0515 19.5 9.625C19.5 4.30938 15.1906 0 9.875 0ZM12.4967 24.8451L11.5621 26.25H8.18735L7.25274 24.8451L7.25219 24.5H12.4967V24.8451ZM12.4989 22.75H7.25055L7.24672 21H12.5011L12.4989 22.75ZM15.802 14.8028C15.037 15.6756 13.8152 17.4333 13.0359 19.2495H6.71461C5.93477 17.4327 4.7136 15.6756 3.94852 14.8028C2.6836 13.3602 2.00712 11.5309 2.00274 9.625C1.9929 5.41461 5.30477 1.75 9.875 1.75C14.2172 1.75 17.75 5.28281 17.75 9.625C17.75 11.5309 17.0582 13.37 15.802 14.8028Z"
        fill={color}
      />
    </svg>
  );
};
